import { shallowRef } from "vue";
import { latLng } from "leaflet";

import { form } from "@/elements/address";
import { courierData } from "@/elements/repository";
import { getElement } from "~/services/dom";
import { currentCenter } from "@/elements";

import Courier from "@/components/Courier.vue";

import type { AccordionObject } from "@/components/accordion/Accordion.vue";
import type { Location } from "@/types";

export const accordions = shallowRef<AccordionObject<Location>[]>([]);

export async function addAccordions() {
	if (!courierData.value || courierData.value.length === 0) {
		console.error("No courier data available for accordions.");
		return;
	}

	const formLatLng = form.value?.latitude && form.value?.longitude ? latLng(+form.value.latitude, +form.value.longitude) : null;

	const accordionItems = courierData.value
		?.filter((accordion) => accordion !== undefined)
		?.flatMap((courier) =>
			courier?.locations?.map((location) => {
				const distance = formLatLng
					? formLatLng.distanceTo([location.geo.latitude, location.geo.longitude])
					: currentCenter.value?.distanceTo([location.geo.latitude, location.geo.longitude]);

				return {
					id: location.id,
					title: location.name,
					icon: courier.courier.images.mark,
					courier: courier.courier.name,
					content: location,
					component: Courier,
					distance
				};
			})
		)
		?.sort((a, b) => {
			if (a.distance === undefined && b.distance === undefined) return 0;
			if (a.distance === undefined) return 1;
			if (b.distance === undefined) return -1;
			return a.distance - b.distance;
		});

	const previousAccordionCount = accordions.value?.length || 0;
	const newAccordionCount = accordionItems.length;

	accordions.value = accordionItems;

	if (newAccordionCount > 0) {
		const nearestAccordion = getElement(`#${accordions.value[0].id}`, document);
		if (nearestAccordion) {
			nearestAccordion.scrollIntoView({ block: "nearest", behavior: "smooth" });
		}
	}

	if (newAccordionCount > previousAccordionCount) {
		const newAccordion = getElement(`${accordionItems[previousAccordionCount].id}`, document);
		if (newAccordion) {
			newAccordion.scrollIntoView({ block: "nearest", behavior: "smooth" });
		}
	}
}
